var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "PeriodicSalesComparison" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.periodicSalesComparison.Code"),
                        error: _vm.$v.form.Code,
                        required: true,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t(
                          "insert.periodicSalesComparison.Description1"
                        ),
                        error: _vm.$v.form.Description1,
                        required: true,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t(
                          "insert.periodicSalesComparison.Definition"
                        ),
                        error: _vm.$v.form.Definiton,
                        required: true,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Definition,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Definition", $$v)
                          },
                          expression: "form.Definition"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t(
                          "insert.periodicSalesComparison.StatusId"
                        ),
                        error: _vm.$v.form.StatusId,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextCheckBox2", {
                        attrs: {
                          type: "number",
                          disabled: _vm.insertReadonly.StatusId,
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.periodicSalesComparison.Definitions"),
                    active: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.PastSalesStart"
                            ),
                            error: _vm.$v.form.PastSaleStartDate,
                            required: true
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.PastSaleStartDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "PastSaleStartDate", $$v)
                              },
                              expression: "form.PastSaleStartDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.PastSalesEnd"
                            ),
                            error: _vm.$v.form.PastSaleEndDate,
                            required: true
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.PastSaleEndDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "PastSaleEndDate", $$v)
                              },
                              expression: "form.PastSaleEndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.PastSalesControlAmount"
                            ),
                            error: _vm.$v.form.PastSaleQuantity,
                            required: true
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: _vm.form.PastSaleQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "PastSaleQuantity", $$v)
                              },
                              expression: "form.PastSaleQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.BranchCriterion"
                            ),
                            error: _vm.$v.form.BranchCriteriaId,
                            required: true
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.lookupValues.BRANCH_CRITERIA,
                              disabled: true,
                              label: "Label"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "BranchCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedBranchCriteria,
                              callback: function($$v) {
                                _vm.selectedBranchCriteria = $$v
                              },
                              expression: "selectedBranchCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.NextSalesStart"
                            ),
                            error: _vm.$v.form.NextSaleStartDate,
                            required: true
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.NextSaleStartDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "NextSaleStartDate", $$v)
                              },
                              expression: "form.NextSaleStartDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.NextSalesEnd"
                            ),
                            error: _vm.$v.form.NextSaleEndDate,
                            required: true
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.NextSaleEndDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "NextSaleEndDate", $$v)
                              },
                              expression: "form.NextSaleEndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.NextSalesControlAmount"
                            ),
                            error: _vm.$v.form.NextSaleQuantity,
                            required: true
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: _vm.form.NextSaleQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "NextSaleQuantity", $$v)
                              },
                              expression: "form.NextSaleQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.ProductCriteria"
                            ),
                            error: _vm.$v.form.ItemCriteriaId,
                            required: true
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              source: _vm.lookupValues.ITEM_CRITERIA
                                ? _vm.lookupValues.ITEM_CRITERIA.filter(
                                    function(i) {
                                      return i.Code != "UL"
                                    }
                                  )
                                : [],
                              label: "Label"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ItemCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedItemCriteria,
                              callback: function($$v) {
                                _vm.selectedItemCriteria = $$v
                              },
                              expression: "selectedItemCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.PastSaleColor"
                            ),
                            required: true
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.pastSaleColorId
                            },
                            model: {
                              value: _vm.pastSaleColorId,
                              callback: function($$v) {
                                _vm.pastSaleColorId = $$v
                              },
                              expression: "pastSaleColorId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.periodicSalesComparison.NextSaleColor"
                            ),
                            required: true
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.nextSaleColorId
                            },
                            model: {
                              value: _vm.nextSaleColorId,
                              callback: function($$v) {
                                _vm.nextSaleColorId = $$v
                              },
                              expression: "nextSaleColorId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedItemCriteria && _vm.selectedItemCriteria.Code === "UL"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t("insert.periodicSalesComparison.Products")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.itemAnalysisItems },
                        model: {
                          value: _vm.periodicSalesItems,
                          callback: function($$v) {
                            _vm.periodicSalesItems = $$v
                          },
                          expression: "periodicSalesItems"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedBranchCriteria &&
              _vm.selectedBranchCriteria.Code === "SL"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t("insert.periodicSalesComparison.Branches")
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "12" } },
                            [
                              _c(
                                "b-card",
                                { staticClass: "m-4 asc__showPage-card" },
                                [
                                  _c(
                                    "b-table-simple",
                                    { attrs: { bordered: "", small: "" } },
                                    [
                                      _c(
                                        "b-thead",
                                        [
                                          _c("b-th", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.fixedTermCampaign.branchCode"
                                                  )
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("b-th", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.fixedTermCampaign.branchName"
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tbody",
                                        _vm._l(
                                          _vm.rowData
                                            .PeriodicSalesComparisonDetails
                                            ? _vm.rowData.PeriodicSalesComparisonDetails.filter(
                                                function(b) {
                                                  return (
                                                    b.TableName == "T_BRANCH"
                                                  )
                                                }
                                              )
                                            : [],
                                          function(b, i) {
                                            return _c(
                                              "b-tr",
                                              { key: i },
                                              [
                                                _c("b-td", [
                                                  _vm._v(_vm._s(b.Code))
                                                ]),
                                                _vm._v(" "),
                                                _c("b-td", [
                                                  _vm._v(_vm._s(b.Description1))
                                                ])
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f83231fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f83231fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PeriodicSalesComparison/update.vue
// module id = null
// module chunks = 